import { RouteNode } from '@aurelia/router';

// The router hands the query of the route being loaded to loading(). ICurrentRoute and window.location still describe
// the previous page at that point (an in-app redirect to login has not changed the address bar yet), so they are only
// a fallback for callers that run outside a navigation.
export function readReturnUrl(next?: RouteNode | null): string | null {
    const fromRoute = next?.queryParams?.get('returnUrl');
    if (fromRoute) {
        return fromRoute;
    }

    return new URLSearchParams(window.location.search).get('returnUrl');
}
